export const PUBLIC_FAMILY_OFFICE = {
  id: 'public_family_office',
  label: 'Sì, presso un consultorio familiare pubblico',
};
export const PUBLIC_HOSPITAL = { id: 'public_hospital', label: 'Sì, presso un ospedale pubblico' };
export const PRIVATE_FACILITY = {
  id: 'private_facility',
  label: 'Sì, presso una struttura privata',
};
export const PREVIOUS_PREGNANCY = {
  id: 'previous_pregnancy',
  label: 'No, ha frequentato un corso in precedente gravidanza',
};
export const NONE = { id: 'none', label: 'No' };
